import {charcoal} from '../../sass/v2/_exports.sass';

export const UserIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2.66666C14.6815 2.66666 13.3925 3.05765 12.2962 3.79019C11.1999 4.52274 10.3454 5.56393 9.8408 6.7821C9.33622 8.00027 9.2042 9.34072 9.46143 10.6339C9.71867 11.9271 10.3536 13.115 11.286 14.0474C12.2183 14.9797 13.4062 15.6147 14.6994 15.8719C15.9926 16.1291 17.333 15.9971 18.5512 15.4925C19.7694 14.9879 20.8106 14.1335 21.5431 13.0371C22.2757 11.9408 22.6667 10.6519 22.6667 9.33332C22.6667 7.56521 21.9643 5.86952 20.714 4.61928C19.4638 3.36904 17.7681 2.66666 16 2.66666ZM16 13.3333C15.2089 13.3333 14.4355 13.0987 13.7777 12.6592C13.1199 12.2197 12.6072 11.595 12.3045 10.8641C12.0017 10.1332 11.9225 9.32889 12.0769 8.55296C12.2312 7.77704 12.6122 7.06431 13.1716 6.5049C13.731 5.94549 14.4437 5.56452 15.2196 5.41018C15.9956 5.25584 16.7998 5.33505 17.5307 5.63781C18.2616 5.94056 18.8864 6.45325 19.3259 7.11104C19.7654 7.76884 20 8.5422 20 9.33332C20 10.3942 19.5786 11.4116 18.8284 12.1618C18.0783 12.9119 17.0609 13.3333 16 13.3333ZM28 28V26.6667C28 24.1913 27.0167 21.8173 25.2663 20.067C23.516 18.3167 21.142 17.3333 18.6667 17.3333H13.3333C10.858 17.3333 8.48401 18.3167 6.73367 20.067C4.98333 21.8173 4 24.1913 4 26.6667V28H6.66667V26.6667C6.66667 24.8985 7.36905 23.2029 8.61929 21.9526C9.86953 20.7024 11.5652 20 13.3333 20H18.6667C20.4348 20 22.1305 20.7024 23.3807 21.9526C24.631 23.2029 25.3333 24.8985 25.3333 26.6667V28H28Z"
        fill={color}
      />
    </svg>
  );
};
